import { useEffect } from 'react';

import { installReachProbe } from '../utils/reachProbe';

/** Пока сервер недоступен при "сети есть", приложение само проверяет, не ожил ли он. */
export const useReachProbe = (): void => {
  useEffect(() => installReachProbe(), []);
};
